<template>
  <div class="ContextMenuComponent">
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" :id="'context-menu-'+id">
      
      <a v-for="item in menu" class="dropdown-item context-menu-item" :id="item.id" :key="item.id" href="#" @click="action">{{item.text}}</a>
      
    </div>
  </div>
</template>

<script>
export default {
  name: "ContextMenuComponent",
  data () {
    return {
  
      
    }
  },
  props:{
    id: String,
    menu: Array
  },
  methods: {

    action (e) {

      let action = e.target.id;
      this.$parent.contextMenu.funcAction(this, action)

            
    }
  }
}
</script>

<style lang="scss">
  .ContextMenuComponent{
    
    
      
         
    
  }

</style>


// WEBPACK FOOTER //
// src/components/shared/ContextMenuComponent.vue